import React from 'react';
import PropTypes from 'prop-types';

import { Text, Flex, Spacer } from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import NoPaymentImage from 'app/shared/images/nopayment@3x.png';

import { StyledImage } from './StyledComponents';

const propTypes = {
    notification: PropTypes.object,
};

const defaultProps = {
    notification: {},
};

const BillingEmptyBanner = ({ notification }) => (
    <Spacer marginY="xl" marginX="xl">
        <Flex display="flex" flexDirection="column" alignItems="center">
            <StyledImage src={NoPaymentImage} alt="No Payments" />
            <Text fontType="h4">{notification.title}</Text>
            {notification.text.map((text, i) => <Center key={i} fontType="body">{text}</Center>)}
        </Flex>
    </Spacer>
);

BillingEmptyBanner.propTypes = propTypes;
BillingEmptyBanner.defaultProps = defaultProps;

export default BillingEmptyBanner;
